module.exports = __webpack_public_path__ + "static/media/runner.67631eda.png";